import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38cfbfbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "modal-positioner flex items-start justify-center min-h-screen pt-24 text-center" }
const _hoisted_3 = { class: "pb-5" }
const _hoisted_4 = { class: "page-title" }
const _hoisted_5 = ["aria-label", "title"]
const _hoisted_6 = { class: "modal" }


import { XIcon } from "@heroicons/vue/outline";


export default /*#__PURE__*/_defineComponent({
  props: {
  title: {
    default: "Title",
    required: false,
  },
  show: {
    type: Boolean,
    default: true,
  },
  wide: {
    type: Boolean,
    default: false,
  },
},
  emits: ["close"],
  setup(__props, { emit }) {

const props = __props





function closeModal() {
  emit("close");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-200 transform",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "transition ease-in duration-200 transform",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          ref: (_value, _refs) => {
            _refs['modal-backdrop'] = _value
          },
          class: "modal-backdrop fixed z-10 inset-0 overflow-y-auto bg-backdrop",
          onClick: _withModifiers(closeModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: _normalizeClass(["modal-dialog relative text-left overflow-hidden card-global rounded-xl w-full mx-4", __props.wide ? 'max-w-6xl' : 'max-w-2xl']),
              role: "dialog",
              ref: (_value, _refs) => {
                _refs['modal'] = _value
              },
              "aria-modal": "true",
              "aria-labelledby": "modal-headline"
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h1", _hoisted_4, _toDisplayString(__props.title), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "modal-close absolute top-4 right-4",
                  "aria-label": _ctx.$t('common.close'),
                  title: _ctx.$t('common.close'),
                  onClick: closeModal
                }, [
                  _createVNode(_unref(XIcon), { style: {"width":"30px"} })
                ], 8, _hoisted_5)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _renderSlot(_ctx.$slots, "default")
              ])
            ], 2)
          ])
        ], 8, _hoisted_1), [
          [_vShow, __props.show]
        ])
      ]),
      _: 3
    })
  ]))
}
}

})